/** Bonus Issue 문서 컴포넌트(BonusDocVarField 등)가 패널의 공유 상태에 접근하는 provide/inject 컨텍스트.
 *  OTC(otcContext) 미러링. Bonus 는 "8문서 패키지 공유 values 맵" 이라 하나의 values/flags/반복부를 공유한다.
 *  (청약자 유형 분기는 없음 — subscriberType 제외.) */
import type { InjectionKey, Ref } from 'vue';
import type { BonusFieldType } from './bonusFields';
import type { ComboOpt } from '../cdd/cddOptions';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

export interface BonusDocContext {
  valueOf: (key: string) => string;
  labelOf: (key: string) => string;
  typeOf: (key: string) => BonusFieldType;
  activeKey: Ref<string>;
  activate: (key: string) => void;              // 변수 클릭 → 패널이 챗봇/입력바 라우팅
  setFieldValue: (key: string, val: string) => void; // 드래그앤드롭·직접 채우기
  openAddress: (key: string) => void;           // 주소 필드 📍 → 주소 입력(모달/챗봇)
  comboOptionsOf: (key: string) => ComboOpt[];

  // ── 조건 토글([[if X]]) ──
  flag: (name: string) => boolean;
  setFlag: (name: string, val: boolean) => void;
  toggleFlag: (name: string) => void;
  /** 문자열 flag(resolution_basis / statement_resolution_basis 등). */
  choiceOf: (name: string) => string;
  setChoice: (name: string, val: string) => void;

  // ── Governing Document (정관 결의 근거) ──
  clauseLocked: Ref<boolean>;
  clauseOptions: Ref<string[]>;
  setClause: (raw: string) => void;

  // ── 반복부: Allottees ──
  allotteeCount: Ref<number>;
  addAllottee: () => void;
  removeAllottee: (index: number) => void;      // 1-based

  // ── 반복부: Share classes (Section 78) ──
  shareClassCount: Ref<number>;
  addShareClass: () => void;
  removeShareClass: (index: number) => void;    // 1-based

  // ── [[Signers]] — 문서별 서명자 선택(SignersField) ──
  entityCd: Ref<string>;
  signersOf: (varKey: string) => SignerEntry[];
  setSigners: (varKey: string, list: SignerEntry[]) => void;

  // ── pick-place (챗봇 상세카드 copy → 필드 클릭 삽입) ──
  pendingPickValue: Ref<string>;
  placePick: (key: string) => boolean;
}

export const BONUS_DOC_CTX: InjectionKey<BonusDocContext> = Symbol('bonusDocCtx');
